/*eslint-disable*/
import * as types from './mutation-types';
import $Cookies from 'js-cookie';
import { common, commonApi } from '@/common/index';
import { Message } from 'element-ui';
import $qs from 'qs';


export const setIndexNav = function({commit, state},index) {
  commit(types.SET_NAV_INDEX,index)
};
export const setMineIndexNav = function({commit, state},index) {
  commit(types.SET_MINE_NAV_INDEX,index)
};
export const setSlotsIndexNav = function({commit, state},index) {
  commit(types.SET_SLOTS_NAV_INDEX,index)
};
export const setCapitalIndexNav = function({commit, state},index) {
  commit(types.SET_MINE_CAPITAL_NAV,index)
};
export const setHelpIndexNav = function({commit, state},index) {
  commit(types.SET_HELP_CAPITAL_NAV,index)
};

// 各游戏平台
export const gameListByPlatform = function ({commit, state}, obj) {
  commit(types.GAME_LIST_BY_PLATFORM, obj)
}

// 老虎机游戏图片链接
export const setSlotPic = function ({commit, state}, picLink) {
  commit(types.SET_SLOT_PIC,picLink)
}

// 一级导航
export const getFirstNav = function ({commit, state}) {
  commonApi.HOMEBEFORE.getFirstNav()
    .then((list) => {
      commit(types.SET_FIRST_NAV, list)
    })
    .catch((err)=> {})
}

export const Login = function ({commit, state}, UUID) {
  commit(types.LOGIN,UUID)
};

export const checkLogin = function ({commit, state}) {
  let url = window.location.href;
  let UUID = $qs.parse(url.split('?')[1]).UUID;

  if (UUID === undefined) {
    UUID = $Cookies.get('UUID')
  } else {
    $Cookies.set('UUID', UUID)
  }
  let obj = {};
  if(UUID) {
    obj['isLogin'] = true;
    obj['UUID'] = UUID;
    commit(types.CHECK_LOGIN, obj)
  }else {
    commit(types.LOGIN_OUT)
  }
};
// 用户信息
export const getFirstInfo = function({commit, state}){
  commonApi.USER.getUserInfo()
    .then((data)=>{
      commit(types.SET_USER_INFO,data)
    })
    .catch((err)=>{
      Message.warning(err)
    })
};
// 获取链接列表
export const initLinkList = function ({commit, state}) {
  commonApi.HOMEBEFORE.initLink()
    .then((data)=>{
      commit(types.INIT_LIST,data)
      data.isNameVerify == '1'?commit('setIsNameVerify',true):commit('setIsNameVerify',false)
      data.isPhoneVerify == '1'?commit('setIsPhoneVerify',true):commit('setIsPhoneVerify',false)
      data.isMailVerify == '1'?commit('setIsMailVerify',true):commit('setIsMailVerify',false)
    })
    .catch((err)=>{
      Message.warning(err)
    })
};
// 取回余额
export const get_covert_vip_wallet = function ({commit, state}) {
  commonApi.PAY.covertVipWallet({
    UUID:state.UUID,
  })
    .then(data => {
      commit('SET_VIP_PAY_INFO', data.data||{})
    })
    .catch(err=>{})
};
// 获取链接列表
export const withdrawInit = function({ commit, state }) {
         commonApi.HOMEBEFORE.withdrawInit()
           .then(data => {
             commit(types.INIT_WITHDRAW, data);
           })
           .catch(err => {
             Message.warning(err);
           });
       };

// 获取新链接列表
export const newinitLinkList = function ({commit, state}) {
  commonApi.HOMEAFTER.getFrontConfigList()
    .then((data)=>{
      commit(types.FRONTCONFIG_LIST,data)
      // data.isNameVerify == '1'?commit('setIsNameVerify',true):commit('setIsNameVerify',false)
    })
    .catch((err)=>{
      Message.warning(err)
    })
};

// 获取维护游戏的列表
export const maintainGameList = function ({commit, state}) {
  commonApi.HOMEBEFORE.allGameInfo()
    .then(data => {
      let list = data.filter(item => item.maintain === '1');
      commit(types.SET_MAINTAIN_GAME_LIST, list)
    })
    .catch(err=>{})
};
// 设置维护信息
export const maintainGameInfo = function ({commit, state},info) {
  commit(types.SET_MAINTAIN_GAME_INFO,info)
}
// 设置维护信息状态
export const maintainGameState = function ({commit, state},boolean) {
  commit(types.SET_MAINTAIN_GAME_STATE,boolean)
}
// 设置站内信条数
export const getInEmail = function({commit, state}){
  let params = {
    UUID:state.UUID,
    pageNo:1,
    pageSize:10,
    read: 0
  }
  commonApi.VIP.getMsgSiteList(params)
  .then(data=>{
    commit(types.SET_INEMAIL,data.total)
  })
  .catch(err=>{
    commit(types.SET_INEMAIL,0)
  })

}

// 获取文章列表
export const getArticleType = function ({commit, state}) {
  commonApi.HELP.getArticleType()
    .then(data=>{
      commit('set_downNav', data)
    })
    .catch(err=>{})
}

/**
 * 多彩宝 */
// 奖池金额
export const addJackPotMoney = function ({commit}) {

  let num = Math.random()*15;
  let moneyNum = parseFloat(num.toFixed(2));

  commit(types.ADD_COLOR_STARTMONEY,moneyNum)
};

export const getColorService = function ({commit}) {
  commonApi.HOMEBEFORE.service()
    .then(customerUrl => {
      customerUrl && commit(types.SET_COLOR_SERVICE,customerUrl)
    })
    .catch(err => {})
}

/**
 * 金色*/
export const setArticleTypeList = function ({commit, state}, list) {
  commit(types.SET_ARTICLETYPELIST,list)
};

/**
 * 金沙 */
export const JIN_SHA_GLOBAL_LOGIN = function ({commit, state}, bool) {
  commit(types.JIN_SHA_GLOBAL_LOGIN,bool)
};

export const BEFORE_LOGIN_GAME_INFO = function ({commit, state}, obj) {
  commit(types.BEFORE_LOGIN_GAME_INFO,obj)
};

export const IS_LOGIN_FOCUS = function ({commit, state}, bool) {
  commit(types.IS_LOGIN_FOCUS,bool)
};

/**
 * 体育*/

export const sports_setTopNav = function ({commit, state},bool) {
  commit(types.SPORTS_SET_TOP_NAV,bool)
}

export const set_spots_nav_index = function ({commit, state}, index) {
  commit(types.SET_SPORTS_NAV_INDEX, index)
}

export const set_is_register_success = function ({commit, state}, boolean) {
  commit(types.SET_IS_REGISTER_SUCCESS, boolean)
}

// 新优惠
export const getBonusInfo = function({commit,state}){
  commonApi.DISCOUNTS.queryBonusArticleTypeList()
  .then(data =>{
    commit(types.SETBONUSTYPES,data)

    let param = {
      typeId:state.BonusTypes[0].articleId,
      platform:'pc',
      pageNo: 1,
      pageSize: 200,
    }
    commonApi.DISCOUNTS.queryBonusArticleInfoList(param)
    .then(data =>{

      data.list && commit('setAllBonusArticle',data.list)

    })
  })
}



// WEBPACK FOOTER //
// ./src/common/store/actions.js